import { DATE_FNS_LOCAL_DATE_FORMAT, FORMAT_LOCAL_DATE_ONLY, FORMAT_LOCAL_DATE_TIME } from '@ag-common-lib/public-api';
import { Pipe, PipeTransform } from '@angular/core';
import { format, isValid, parse, setHours, setMilliseconds, setMinutes, setSeconds } from 'date-fns';

@Pipe({
  name: 'formatLocalDate',
})
export class FormatLocalDatePipe implements PipeTransform {
  transform(localDate: string, isAllDay: boolean = false): string {
    if (!localDate) {
      return '';
    }

    let parsedDate = parse(localDate, DATE_FNS_LOCAL_DATE_FORMAT, new Date());

    if (!isValid(parsedDate)) {
      return '';
    }

    if (isAllDay) {
      parsedDate = setHours(parsedDate, 0);
      parsedDate = setMinutes(parsedDate, 0);
      parsedDate = setSeconds(parsedDate, 0);
      parsedDate = setMilliseconds(parsedDate, 0);
    }

    const dateFormat = isAllDay ? FORMAT_LOCAL_DATE_ONLY : FORMAT_LOCAL_DATE_TIME;

    return format(parsedDate, dateFormat);
  }
}
